<template>
    <b-modal ref="mdlAccettazioneNRE" id="mdlAccettazioneNRE" size="xl" @shown="onShownModal"
        style="height: 100%; width: 100%" no-close-on-backdrop no-close-on-esc hide-header-close
        title="Accettazione NRE">
        <div class="sa-ft-grid">
            <!---  <div class="sa-ft-field flex-main">
                <div class="sa-ft-icon-box">👤</div>
                <div class="sa-ft-inner-row">
                    <div class="sa-ft-inner-column flex-main">
                        <label class="sa-ft-form-label">Codice Fiscale</label>
                        <input class="sa-ft-form-input" v-model="codiceFiscale" type="text">
                    </div>
                </div>
            </div>-->
            <div class="sa-ft-field flex-main">
                <div class="sa-ft-icon-box">𝄃𝄃𝄂𝄀𝄁𝄃𝄂𝄂𝄃</div>
                <div class="sa-ft-inner-row">
                    <div class="sa-ft-inner-column flex-main">
                        <label class="sa-ft-form-label">Numero Ricetta Elettronica</label>
                        <input class="sa-ft-form-input" v-model="nre" @keyup.enter="onRicercaAssistito" type="text">
                    </div>

                    <button type="button" @click="onRicercaAssistito" class="sa-ft-action-btn primary">
                        <span>Ricerca</span>
                        <small>🔍</small>
                    </button>
                </div>
            </div>
        </div>

        <section class="sa-ft-section-container" v-if="jsonDataIntegrazione != null && isCallComplete">
            <div class="sa-ft-card-header" v-if="!jsonDataIntegrazione.patientExist">
                <div class="sa-ft-section-icon">⚠️</div>
                <label class="sa-ft-label"> Prevista Registrazione Paziente</label>
            </div>
            <div class="sa-ft-card-header" v-else>
                <div class="sa-ft-section-icon">✅</div>
                <label class="sa-ft-label"> Paziente già registrato in piattaforma</label>
            </div>
            <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill @input="onInputTabs">
                <b-tab style="height: 500px !important; width: 100%; overflow-y: scroll;" id="tbAnagrafica"
                    title="Dati Anagrafici" active>
                    <!-- <accettazione-ssn-anagrafica-component-n @changeJsonData="onChangeJsonData"
                        :initJsonData="jsonDataIntegrazione" ref="cmpAccettazioneSsnAnagraficaComponentN"
                        :isEdit="true" /> -->
                    <RsaAccettazioneAnagraficaComponent @changeJsonData="onChangeJsonData"
                        :jsonData="jsonDataIntegrazione.accettazione" ref="cmpRsaAccettazioneAnagrafica" :isEdit="true">

                        <template #anagrafica-info>

                            <b-card class="sa-card sa-card-border" header="Gruppo Appartenenza" header-tag="header"
                                footer-tag="footer" title="">
                                <b-row class="sa-padding-left text-left"
                                    style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
                                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div role="statocivileselect">
                                            <label class="sa-label-data">Gruppo <span
                                                    style="color: red">*</span></label>
                                            <b-form-select v-model="jsonDataIntegrazione.accettazione.gruppo"
                                                placeholder="Inserisci Stato Civile" :options="gruppoOptions"
                                                value-field="descrizione" text-field="descrizione">
                                                <template #first>
                                                    <b-form-select-option :value="null">- Seleziona
                                                        -</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </template>

                    </RsaAccettazioneAnagraficaComponent>


                </b-tab>
                <b-tab style="height: 500px !important; width: 100%; overflow-y: scroll;" title="Impegnativa">
                    <div v-for="(ricetta, indexRicetta) in jsonDataIntegrazione.ricette" :key="indexRicetta">
                        <section class="sa-ft-section-container">
                            <div class="sa-ft-form-card">
                                <div class="sa-ft-card-header">
                                    <div class="sa-ft-section-icon">🧾</div>
                                    <h3>Ricetta</h3>
                                    <div style="display: table; margin-left: auto; text-align: right;">
                                        <label class="sa-ft-label">Priorità</label>
                                        <div style="display: table; margin-left: auto; text-align: right;">
                                            <div class="sa-ft-circle-wrapper-orange">{{ ricetta.classePriorita }} </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-1">
                                        <div class="sa-ft-icon-box">🏷️</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Tipologia Ricetta</label>
                                            <span class="sa-ft-value">{{ ricetta.tipologiaRicetta }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-1">
                                        <div class="sa-ft-icon-box">𝄃𝄃𝄂𝄀𝄁𝄃𝄂𝄂𝄃</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">NRE</label>
                                            <span class="sa-ft-value">{{ ricetta.codiceBar1 }}{{ ricetta.codiceBar2
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-1">
                                        <div class="sa-ft-icon-box">👤</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Codice Fiscale Assistito</label>
                                            <span class="sa-ft-value">{{ ricetta.codiceFiscaleAssistito }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-3">
                                        <div class="sa-ft-icon-box">📅</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Data Prescrizione</label>
                                            <span class="sa-ft-value">{{ formatDateTime(ricetta.dataPrescrizione)
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-auto">
                                        <div class="sa-ft-icon-box">🧾</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Esenzione</label>
                                            <span class="sa-ft-value">{{ ricetta.codiceEsenzione }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-auto">
                                        <div class="sa-ft-icon-box">🧾</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Non Esente</label>
                                            <span class="sa-ft-value" v-if="ricetta.nonEsente">✅</span>
                                            <span class="sa-ft-value" v-else>❌</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-auto">
                                        <div class="sa-ft-icon-box">🧾</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Esenzione Reddito</label>
                                            <span class="sa-ft-value" v-if="ricetta.esenteReddito">✅</span>
                                            <span class="sa-ft-value" v-else>❌</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="sa-ft-card-header">
                                    <div class="sa-ft-section-icon">💲</div>
                                    <h3>Pagamento ticket</h3>

                                </div>
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-3">
                                        <div class="sa-ft-icon-box">🏛️</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Stato Pagamento</label>
                                            <span class="sa-ft-value">{{ ricetta.cashStatus
                                                }}</span>
                                            <small>{{ ricetta.iuvPaymentStatus
                                                }}</small>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-icon-box">💴</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Ticket a Carico Paziente</label>
                                            <span class="sa-ft-value">{{
                                                Number(ricetta.personBillAmount).toLocaleString('it-IT',
                                                    { style: 'currency', currency: 'EUR' }) }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-icon-box">💵</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Ticket pagato da Paziente</label>
                                            <span class="sa-ft-value">{{
                                                Number(ricetta.personCashedAmount).toLocaleString('it-IT',
                                                    { style: 'currency', currency: 'EUR' })
                                            }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="sa-ft-card-header" v-b-toggle="'collapse-prestazioni'">
                                    <div class="sa-ft-section-icon">🚀</div>
                                    <h3>Prestazioni</h3>
                                    <div style="display: table; margin-left: auto; text-align: right;">
                                        <span class="sa-ft-circle-wrapper"> {{ ricetta.prestazioni.length }}</span>
                                    </div>
                                    <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange"
                                        :class="{ 'is-open': isOpen }">▼</span>
                                </div>
                                <b-collapse @show="gestisciApertura()" @hide="gestisciChiusura()"
                                    :id="'collapse-prestazioni'">
                                    <div class="sa-ft-modern-cards-wrapper"
                                        v-for="(prestazione, index) of ricetta.prestazioni" :key="index">
                                        <li style="width: 100% !important; padding: 5px;">
                                            <div class="sa-ft-modern-card sa-ft-modern-card-default">
                                                <div class="sa-ft-grid">
                                                    <div class="sa-ft-field-normal flex-auto">
                                                        <div class="sa-ft-data">
                                                            <span class="sa-ft-data-value"
                                                                style="font-size: 2.0rem; line-height: 1;">⚡</span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-main">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Prestazione</label>
                                                            <span class="sa-ft-data-value">{{
                                                                prestazione.descrizionePrestazione }}</span>
                                                            <span class="sa-ft-data-value-sub cursive">{{
                                                                prestazione.codicePrestazione
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-2 text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Agenda</label>
                                                            <span class="sa-ft-data-value"
                                                                v-if="prestazione.appuntamenti[0]">
                                                                <template
                                                                    v-if="prestazione.appuntamenti[0].agendeDisponibilitaPrestazione">
                                                                    <template
                                                                        v-if="prestazione.appuntamenti[0].agendeDisponibilitaPrestazione.length > 0">
                                                                        <b-form-select
                                                                            id="inline-form-custom-select-pref"
                                                                            v-model="prestazione.appuntamenti[0].idAgenda"
                                                                            class="mb-2 mr-sm-2 mb-sm-0" :value="null"
                                                                            value-field="id" text-field="titolo"
                                                                            :options="prestazione.appuntamenti[0].agendeDisponibilitaPrestazione">
                                                                            <template #first>
                                                                                <b-form-select-option
                                                                                    :value="null">NESSUNA</b-form-select-option>
                                                                            </template>
                                                                        </b-form-select>
                                                                    </template>
                                                                    <template v-else>
                                                                        Prestazione non censita in agende !
                                                                    </template>
                                                                </template>

                                                            </span>

                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-1 text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Stato</label>
                                                            <span class="sa-ft-data-value">
                                                                <span class="sa-ft-badge primary">
                                                                    {{ prestazione.statoAttuale.toUpperCase() }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-auto text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Quantita</label>
                                                            <span class="sa-ft-data-value">
                                                                <span class="sa-ft-badge primary">
                                                                    {{ prestazione.quantita }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-auto text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Tariffa</label>
                                                            <span class="sa-ft-data-value">
                                                                <span class="sa-ft-badge primary">
                                                                    {{ formatEuro(prestazione.prezzo) }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-1 text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Appuntamento
                                                                <b-button size="sm" variant="outline-primary"
                                                                    class="ml-1 p-1" style="line-height: 1;"
                                                                    v-b-tooltip.hover title="Gestione Appuntamento"
                                                                    @click="onClickGestioneAppuntamento(ricetta, prestazione, index, indexRicetta)">
                                                                    <b-icon icon="gear"></b-icon>
                                                                </b-button>
                                                            </label>
                                                            <span class="sa-ft-data-value">
                                                                <div class="sa-ft-value-combine-wrapper">
                                                                    <div class="sa-ft-value-combine"
                                                                        v-for="appuntamento of prestazione.appuntamenti"
                                                                        :key="appuntamento.id">
                                                                        <div class="sa-ft-value-combine-row">
                                                                            <span
                                                                                class="sa-ft-value-combine-label">I:</span>
                                                                            <span class="sa-ft-value-combine-value">
                                                                                {{
                                                                                    formattaData(appuntamento.dataRiferimento)
                                                                                }}
                                                                                {{
                                                                                    appuntamento.dalleOre
                                                                                }}</span>
                                                                        </div>
                                                                        <div class="sa-ft-value-combine-row">
                                                                            <span
                                                                                class="sa-ft-value-combine-label">F:</span>
                                                                            <span class="sa-ft-value-combine-value">
                                                                                {{
                                                                                    formattaData(appuntamento.dataRiferimento)
                                                                                }}
                                                                                {{
                                                                                    appuntamento.alleOre
                                                                                }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                </b-collapse>
                            </div>
                        </section>
                    </div>
                </b-tab>
            </b-tabs>
        </section>
        <gestione-appuntamento-modal-component @conferma-single-appuntamento="onConfermaAppuntamento"
            ref="mdlGestioneAppuntamento" />
        <template #modal-footer>
            <div class="w-100">
                <p class="float-left">Conferma per Dati Anagrafici e Prestazioni</p>
                <b-button :disabled="isBtnDisabled()" variant="primary" size="sm" class="float-right ml-3"
                    @click="onConfermaDatiPaziente">
                    👉 Conferma Dati Paziente
                </b-button>
                <b-button variant="primary" size="sm" class="float-right" @click="closeModalAccettazioneNre">
                    ❌ Annulla
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import toast from "../../../../template/layout/utility/sa-toast";

import GestioneAppuntamentoModalComponent from "../../appuntamenti/components/GestioneAppuntamentoModalComponent.vue";
import SaccSarrMixin from "../mixins/SaccSarrMixin";
import RsaAccettazioneAnagraficaComponent from "../../../rsa/rsaaccettazione/components/RsaAccettazioneAnagraficaComponent.vue";

export default {
    // AccettazioneSsnAnagraficaComponentN
    components: { GestioneAppuntamentoModalComponent, RsaAccettazioneAnagraficaComponent },
    mixins: [SaccSarrMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            nre: null,
            gruppoOptions: [],
            presidio: {},
            openPrestazioni: false,
            codiceStruttura: null,
            codicePresidio: null,
            isOpen: false,
            codiceFiscale: "",
            agendaSelezionataAppuntamento: null,
            jsonData: {
                patient: {
                    code: null,
                    name: null,
                },
                details: []
                //details: [{ "id": 77579178, "service": { "id": "89.7A.3_0_N24", "code": "89.7A.3_0", "name": "PRIMA VISITA CARDIOLOGICA. INCLUSO: ECG (89.52)", "startDate": "2024-12-30T00:00:00.000+00:00", "endDate": "2999-12-31T00:00:00.000+00:00", "weight": 1, "groupId": "PA" }, "specialization": { "id": "24-08", "name": "CARDIOLOGIA - 24" }, "requiresSpecificConsent": false, "price": 33.6, "variablePrice": "N", "quantity": 1, "booking": { "id": "26075826", "code": "11711200000126", "startTime": "1900-01-01T11:40:00Z", "endTime": "1900-01-01T12:00:00Z", "diary": { "id": "16929821" }, "registrationUser": { "id": "1002323", "name": "BRNFPP97B07H501V" } }, "executionUnit": { "id": "UE-FRO-00016668", "name": "[CASRAFCARDGAMB] - CARDIOLOGIA DOTT. GAMBARDELLA" }, "scheduledDatetime": "2026-04-28T10:40:00Z", "executionDatetime": "2026-04-28T10:40:00Z", "status": { "id": "ACT", "name": "Accettata" }, "enable": "Y", "statusReason": { "id": "3", "name": "Indicazione del medico erogatore" }, "phoneNumber": "3123123123", "site": { "id": "SIT-FRO-00000951", "name": "SAN RAFFAELE CASSINO CASA DI CURA PRIVATA ACCREDITATA", "address": "VIA GAETANO DI BIASIO, 1" }, "hospital": { "id": "HOS-FRO-00001088", "name": "SAN RAFFAELE CASSINO CASA DI CURA PRIVATA ACCREDITATA" }, "authority": { "id": "STR0000375", "name": "ASL FROSINONE", "code": "120112" } }]
            },
            isCallComplete: false,
            jsonDataIntegrazione: {
                accettazione: {},
                patientExist: false
            },

        }
    },
    mounted() {
        this.loadGruppoAccettazioneSsn();
        let tmpPresidio = window.localStorage.getItem("presidio");
        if (tmpPresidio != "null") {
            this.presidio = JSON.parse(tmpPresidio);
            this.codiceStruttura = this.presidio.codiceStruttura;
            this.codicePresidio = this.presidio.codicePresidio;
        }
    },
    methods: {
        onAgendaChange(appuntamento, idAgendaSelezionata) {
            // idAgendaSelezionata è il value-field selezionato (idAgenda)
            const agendaScelta = appuntamento.agendeDisponibilitaPrestazione
                .find(a => a.idAgenda === idAgendaSelezionata);
            console.log(agendaScelta);

            if (agendaScelta) {
                appuntamento.titoloAgenda = agendaScelta.titolo;
            }
        },
        isBtnDisabled() {
            if (!this.jsonDataIntegrazione) {
                return true;
            }
            if (!this.jsonDataIntegrazione.ricette) {
                return true;
            }
            if (this.jsonDataIntegrazione.ricette.length == 0) {
                return true;
            }
            if (!this.jsonDataIntegrazione.ricette[0].prestazioni) {
                return true;
            }

            return this.jsonDataIntegrazione.ricette[0].prestazioni
                .flatMap(p => p.appuntamenti)
                .some(a => a.idAgenda == null)


        },
        open() {
            this.$refs.mdlAccettazioneNRE.show();
        },
        close() {
            this.$refs.mdlAccettazioneNRE.hide();
        },

        togglePrestazioni() {
            this.openPrestazioni = !this.openPrestazioni;
        },
        onConfermaDatiPaziente() {
            this.openShowModalLoading()
            delete this.jsonDataIntegrazione.integrationAccettazione;
            delete this.jsonDataIntegrazione.accettazionePrestazioni;
            let link = process.env.VUE_APP_PATH_API + "/accettazionessn";
            axios.post(link, this.jsonDataIntegrazione).then((response) => {
                this.$router.push("/accettazionessn");
                this.close();
                this.$emit("afterSaved", response)
                this.closeShowModalLoading();
            }).catch((err) => {
                this.closeShowModalLoading();
                toast.error(err.response.data.messaggio)
            });

        },
        onInputTabs(i) {
            switch (i) {
                case 0:
                    this.$nextTick(() => {
                        this.$refs.cmpRsaAccettazioneAnagrafica.init();
                    });
                    break;

                default:
                    break;
            }
        },
        loadGruppoAccettazioneSsn() {
            let me = this;
            me.gruppoOptions = [];
            let link = process.env.VUE_APP_PATH_API + "/accettazionessngruppi";
            axios.get(link).then((response) => {
                me.gruppoOptions = response.data.data.list;
            });
        },
        onConfermaAppuntamento(row, index, indexRicetta) {
            this.jsonDataIntegrazione.ricette[indexRicetta].prestazioni[index].appuntamenti[0].dataRiferimento = row.dataRiferimento;
            this.jsonDataIntegrazione.ricette[indexRicetta].prestazioni[index].appuntamenti[0].dataOraInizio = row.dataOraInizio;
            this.jsonDataIntegrazione.ricette[indexRicetta].prestazioni[index].appuntamenti[0].dataOraFine = row.dataOraFine;
            this.jsonDataIntegrazione.ricette[indexRicetta].prestazioni[index].appuntamenti[0].dalleOre = this.formatTime(row.dataOraInizio);
            this.jsonDataIntegrazione.ricette[indexRicetta].prestazioni[index].appuntamenti[0].alleOre = this.formatTime(row.dataOraFine);
            this.jsonDataIntegrazione.ricette[indexRicetta].prestazioni[index].appuntamenti[0].idAgenda = row.idAgenda;
        },
        onClickGestioneAppuntamento(ricetta, prestazione, index, indexRicetta) {
            let app = prestazione.appuntamenti[0];
            let row = {
                idPrestazione: prestazione.id,
                codicePrestazione: prestazione.codicePrestazione,
                descrizionePrestazione: prestazione.descrizionePrestazione,
                identificativoAppuntamento: ricetta.codiceFiscaleAssistito,
                statoAttuale: prestazione.statoAttuale,
                costo: prestazione.prezzo,
                codiceBar1: ricetta.codiceBar1,
                codiceBar2: ricetta.codiceBar2,
                quantitaErogabile: prestazione.quantita,
                index: index
            };
            let appuntamento = {
                dataRiferimento: app.dataRiferimento,
                dataOraInizio: app.dataOraInizio,
                dataOraFine: app.dataOraFine,
                numeroOrdine: app.numeroOrdine,
                codicePrestazione: app.codicePrestazione,
                descrizionePrestazione: app.descrizionePrestazione,
                idAgenda: app.idAgenda
            }

            this.$refs.mdlGestioneAppuntamento.showSingleAppuntamento(row, prestazione.appuntamenti[0].agendeDisponibilitaPrestazione, appuntamento, indexRicetta);
        },
        formattaData(dataString) {
            if (!dataString) return '';
            // Separa l'anno, il mese e il giorno [yyyy, mm, dd]
            const parti = dataString.split('-');
            // Li riunisce al contrario: dd/mm/yyyy
            return `${parti[2]}/${parti[1]}/${parti[0]}`;
        },
        onChangeJsonData(json) {
            this.jsonDataIntegrazione = JSON.parse(JSON.stringify(json));
            this.jsonDataIntegrazione.accettazioneAnagrafica = this.jsonDataIntegrazione.accettazione.accettazioneAnagrafica;
        },
        onRicercaAssistito() {
            if (this.nre == null || this.nre.trim() == "") {
                toast.error("Inserire NRE valido !")
                this.closeShowModalLoading();
                return;
            }
            this.openShowModalLoading();
            this.isCallComplete = false;
            let filter = {
                nre: this.nre
            }
            let link = process.env.VUE_APP_PATH_API + "/saccsarrlazio/integrazionenre/" + this.codiceStruttura + "/" + this.codicePresidio;
            axios.get(link, { params: filter }).then((response) => {
                this.jsonDataIntegrazione = response.data.data;
                this.isCallComplete = true;
                this.closeShowModalLoading();
                this.$nextTick(() => {
                    if (this.$refs.cmpRsaAccettazioneAnagrafica) {
                        this.$refs.cmpRsaAccettazioneAnagrafica.init();
                    }
                });

            }).catch((err) => {
                toast.error(err.response.data.messaggio)
                this.isCallComplete = false;
                this.closeShowModalLoading();
            });
        },
        gestisciApertura(item, index) {
            if (item) {
                this.$set(item, 'isOpen', true);
                console.log(`Gruppo ${index} aperto`);
            }
            this.isOpen = true;
        },
        gestisciChiusura(item, index) {
            if (item) {
                this.$set(item, 'isOpen', false);
                console.log(`Gruppo ${index} chiuso`);
            }
            this.isOpen = false;
        },
        formatEuro(value) {
            if (value === null || value === undefined || isNaN(value)) return '€ 0,00';

            return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR'
            }).format(value);
        },
        onShownModal() {
            this.resetAll();

        },
        closeModalAccettazioneNre() {
            this.resetAll();
            this.close();

        },
        getOra(date) {
            return moment(date).format("HH:mm");
        },
        getFormatDate(date) {
            return moment(date).format("DD/mm/yyyy");
        },
        resetAll() {
            this.isCallComplete = false;
            this.nre = null;
            this.isOpen = false;
            this.jsonDataIntegrazione = { accettazione: {}, patientExist: false };
            // this.resetJsonData();
        },
        resetJsonData() {
            this.jsonData = {
                patient: {
                    code: null,
                    name: null,
                },
                details: []
            }
        }

    }
}
</script>

<style lang="scss" scoped>
.cursive {
    font-family: cursive !important;
}

.sa-ft-arrow-icon {
    display: inline-block;
    transition: transform 0.3s ease;
    font-size: 0.8rem;
    /* Regola la dimensione a piacimento */
    color: #6c757d;
    /* Colore grigio neutro, personalizzabile */
}

/* Quando il pannello è aperto, ruota la freccia verso l'alto */
.sa-ft-arrow-icon.is-open {
    transform: rotate(180deg);
}

.sa-ft-circle-wrapper {
    /* Dimensioni e Forma */
    width: 30px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;

    /* Centratura del numero */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Estetica */
    background-color: #007bff21;
    color: rgba(0, 47, 255, 0.712);
    font-family: sans-serif;
    font-weight: bold;
    font-size: 1.2rem;

    /* Opzionale: bordino o ombra */
    border: 2px solid #0056b3;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.sa-ft-circle-wrapper-orange {
    /* Dimensioni e Forma */
    width: 30px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;

    /* Centratura del numero */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Estetica */
    background-color: #ff660021;
    color: rgba(233, 71, 22, 0.801);
    font-family: sans-serif;
    font-weight: bold;
    font-size: 1.2rem;

    /* Opzionale: bordino o ombra */
    border: 2px solid #b34800;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>